<div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
</div>
